import objectPath from 'object-path'
import { checkTableColumnCondition } from '../action/Condition'

export const createActionConditionHelper = ({
  tableColumnList = [],
  formData,
  datasourceValue,
  tabParamActive,
  designContext,
}) => {
  const checkLockAction = (itemAction, actionKey, rowData) => {
    let filterTableCondition = tableColumnList.filter(
      ({ conditions = [] }) => conditions.length > 0,
    )
    let legacyLockKey = {
      actionEdit: 'isLockActionEdit',
      actionDelete: 'isLockActionDelete',
      actionPrint: 'isLockActionPrint',
      actionOther: 'isLockActionOther',
    }[actionKey]
    let checkLock = false
    filterTableCondition.forEach((column) => {
      let { conditions } = column
      conditions.forEach((condition) => {
        let { value, valueType = 'equalValue', lockIcon = [] } = condition
        let action = objectPath.get(condition, [actionKey])
        let isLock =
          action === 'lock' ||
          (legacyLockKey && objectPath.get(condition, legacyLockKey))
        let checkIcon = true
        if (actionKey === 'actionIcon') {
          checkIcon = lockIcon.find(({ name }) => name === itemAction.name)
        }
        if (!isLock) return
        let passValue = checkTableColumnCondition({
          condition: { ...condition, value, valueType },
          column,
          rowData,
          formData,
          datasourceValue,
          tabParamActive,
          designContext,
        })
        if (passValue && isLock && checkIcon) {
          checkLock = true
        }
      })
    })
    return checkLock
  }

  const checkHiddenAction = (itemAction, actionKey, rowData) => {
    let filterTableCondition = tableColumnList.filter(
      ({ conditions = [] }) => conditions.length > 0,
    )
    let isHidden = false
    filterTableCondition.forEach((column) => {
      let { conditions } = column
      conditions.forEach((condition) => {
        let { value, valueType = 'equalValue', hideIcon = [] } = condition
        let action = objectPath.get(condition, [actionKey])
        let isHide = action === 'hide'
        let checkIcon = true
        if (actionKey === 'actionIcon') {
          checkIcon = hideIcon.find(({ name }) => name === itemAction.name)
        }
        if (!isHide) return
        let passValue = checkTableColumnCondition({
          condition: { ...condition, value, valueType },
          column,
          rowData,
          formData,
          datasourceValue,
          tabParamActive,
          designContext,
        })
        if (passValue && isHide && checkIcon) {
          isHidden = true
        }
      })
    })
    return isHidden
  }

  const checkEditHidden = (rowData) => {
    let isHidden = false
    tableColumnList.forEach((column) => {
      let conditions = column?.conditions
      if (conditions) {
        conditions.forEach((condition) => {
          let { value, valueType = 'equalValue', actionEdit } = condition
          let isHide = actionEdit === 'hide'
          let passValue = checkTableColumnCondition({
            condition: { ...condition, value, valueType },
            column,
            rowData,
            formData,
            datasourceValue,
            tabParamActive,
            designContext,
          })
          if (passValue && isHide) {
            isHidden = true
          }
        })
      }
    })
    return isHidden
  }

  const checkRowEditable = (rowData) => {
    let isEditable = true
    tableColumnList.forEach((column) => {
      let conditions = column?.conditions
      if (conditions) {
        conditions.forEach((condition) => {
          let {
            value,
            valueType = 'equalValue',
            isLockActionEdit,
            actionEdit,
          } = condition
          let isLock = actionEdit === 'lock' || isLockActionEdit
          let passValue = checkTableColumnCondition({
            condition: { ...condition, value, valueType },
            column,
            rowData,
            formData,
            datasourceValue,
            tabParamActive,
            designContext,
          })
          if (passValue && isLock) {
            isEditable = false
          }
        })
      }
    })
    return isEditable
  }

  const checkDeleteHidden = (rowData) => {
    let isHidden = false
    tableColumnList.forEach((column) => {
      let conditions = column?.conditions
      if (conditions) {
        conditions.forEach((condition) => {
          let { value, valueType = 'equalValue', actionDelete } = condition
          let isHide = actionDelete === 'hide'
          let passValue = checkTableColumnCondition({
            condition: { ...condition, value, valueType },
            column,
            rowData,
            formData,
            datasourceValue,
            tabParamActive,
            designContext,
          })
          if (passValue && isHide) {
            isHidden = true
          }
        })
      }
    })
    return isHidden
  }

  const checkRowDeletable = (rowData) => {
    let isDeletable = true
    tableColumnList.forEach((column) => {
      let conditions = column?.conditions
      if (conditions) {
        conditions.forEach((condition) => {
          let {
            value,
            valueType = 'equalValue',
            isLockActionDelete,
            actionDelete,
          } = condition
          let isLock = actionDelete === 'lock' || isLockActionDelete
          let passValue = checkTableColumnCondition({
            condition: { ...condition, value, valueType },
            column,
            rowData,
            formData,
            datasourceValue,
            tabParamActive,
            designContext,
          })
          if (passValue && isLock) {
            isDeletable = false
          }
        })
      }
    })
    return isDeletable
  }

  const applyEditableConditions = (newEditable) => {
    return {
      ...newEditable,
      isEditHidden: (rowData) => checkEditHidden(rowData),
      isEditable: (rowData) => checkRowEditable(rowData),
      isDeleteHidden: (rowData) => checkDeleteHidden(rowData),
      isDeletable: (rowData) => checkRowDeletable(rowData),
    }
  }

  return {
    checkLockAction,
    checkHiddenAction,
    checkEditHidden,
    checkRowEditable,
    checkDeleteHidden,
    checkRowDeletable,
    applyEditableConditions,
  }
}
